import React from 'react'

export const ReviewerContext = React.createContext({
  ability: [],
  onActionMakeChange: null,
  onActionStayInReview: null,
  onActionPutOnHold: null,
  onActionOrderApproved: null,
})
